
export default "/assets/paper-airplane-micro.1f636173.svg"